import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=94c4719e&scoped=true&"
import script from "./CollectionDetail.vue?vue&type=script&lang=ts&"
export * from "./CollectionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=94c4719e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c4719e",
  null
  
)

export default component.exports